(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qatc]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var id = Number(btn.dataset.variantId);
    if (!id || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
        if (window.JHCart) {
          window.JHCart.refresh();
          window.JHCart.open();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
      });
  }, true);
})();
